import React, { useState } from "react";

function MapList({ maps, hoveredMap, onHover, onClick }) {
  return (
    <div className="map-list">
      {maps.map((map, index) => (
        <MapListItem
          key={map.id}
          map={map}
          index={index}
          hovered={hoveredMap?.id === map.id}
          onHover={() => onHover(map)}
          onClick={() => onClick(map)}
        />
      ))}
    </div>
  );
}

function MapListItem({
  map,
  hovered,
  onHover,
  onClick
}) {
  return (
    <button
      className={`map-list-item  ${hovered ? "hovered" : ""}`}
      onMouseEnter={onHover}
      onClick={onClick}
    >
      <span className="map-name">
        {map.name}
      </span>
    </button>
  );
}

function MapPreview({ map }) {
  const [bombSites, setBombSites] = useState([]);

  React.useEffect(() => {
    let mounted = true;

    const loadBombSites = async () => {
      if (!map?.basemap) {
        setBombSites([]);
        return;
      }

      setBombSites([]);
      try {
        const mapData = (await import(`../../data/maps/r6s/${map.basemap}.json`)).default;
        if (mounted) {
          setBombSites(Array.isArray(mapData.sites) ? mapData.sites : []);
        }
      } catch (err) {
        console.error(`Failed to load bomb sites for ${map.name}:`, err);
        if (mounted) setBombSites([]);
      }
    };

    loadBombSites();
    return () => {
      mounted = false;
    };
  }, [map?.basemap, map?.name]);

  if (!map) return null;

  return (
    <aside className="map-preview">

      <div className="preview-image-container">
        <img
          key={map.id}
          src={map.image}
          alt={map.name}
          className="preview-image"
        />

        <div className="image-overlay" />
      </div>

      <div className="preview-content">
        {bombSites.map((site, index) => (
          <p className="preview-bomb-site" key={site.id || `${map.id}-site-${index}`}>
            {site.label || site}
          </p>
        ))}
      </div>

    </aside>
  );
}

function R6GameHome({ game, onMapSelect, onBackToGameSelect }) {
    const [mapList, setMapList] = useState([]);
    const [hoveredMap, setHoveredMap] = useState(null);
    
    React.useEffect(() => {
        let mounted = true;
        const loadMaps = async () => {
          if (!game) {
            setMapList([]);
            return;
          }
    
          try {
            let data;
            try {
              data = (await import(`../../data/maps/r6s/maps.json`)).default;
            } catch (err) {
              throw new Error(`Failed to load /src/data/maps/r6s/maps.json: ${err.message}`);
            }
    
            if (!mounted) return;
    
            const allMaps = Array.isArray(data.maps) ? data.maps : [];
            const makeId = (item) => item.id || item.name.toLowerCase().replace(/\s+/g, "_");
            const mapsArr = allMaps.map((item) => ({
              ...item,
              id: makeId(item),
              image: `/maps/R6S/${item.basemap}/${makeId(item)}_preview.webp`,
              bomb_sites: item.sites || [],
              disabled: false,
            }));
            setMapList(mapsArr);
            setHoveredMap(mapsArr[0] || null);
          } catch (err) {
            console.error(err);
            if (!mounted) return;
            setMapList([]);
          }
        };
    
        loadMaps();
        return () => {
          mounted = false;
        };
      }, [game]);
    

    const handleMapClick = (map) => {
        onMapSelect(map.id);
    };

    return (
    <div className="r6-game-home">
        <div className="game-home-top">
          <button
            type="button"
            className="game-home-logo-button"
            aria-label="Return to game selection"
            onClick={onBackToGameSelect}
          >
            <img src="/games/TacMaps_Logo.png" alt="" width="100px" />
          </button>
        <div className="game-home-title">
          R6S TacMaps
          </div>
      </div>

      <div className="map-content">

        <MapList
          maps={mapList}
          hoveredMap={hoveredMap}
          onHover={setHoveredMap}
          onClick={handleMapClick}
        />

        <MapPreview key={hoveredMap?.id} map={hoveredMap} />

      </div>
    </div>
  );

} export default R6GameHome;
